import { Building2, Heart, Shield, Users, Film } from 'lucide-react';
import { Link } from 'react-router-dom';

export const AboutUs = () => {
  return (
    <div className="min-h-screen pt-24" data-testid="about-page">
      {/* Hero */}
      <section className="relative py-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-[var(--primary)]/10 to-transparent" />
        <div className="section-container relative z-10">
          <span className="text-[var(--primary)] text-xs uppercase tracking-[0.3em] block mb-4">
            Conócenos
          </span>
          <h1 className="font-['Playfair_Display'] text-5xl md:text-6xl text-white mb-6">
            Quiénes Somos
          </h1>
          <p className="text-2xl text-white/70 max-w-3xl font-light">
            Pasión por la Cultura, Visión de Futuro
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="section-container py-16">
        <div className="max-w-4xl mx-auto">
          {/* Intro */}
          <div className="mb-16">
            <div className="flex items-center gap-3 mb-6">
              <Heart size={28} className="text-[var(--primary)]" />
              <h2 className="font-['Playfair_Display'] text-3xl text-white">
                El corazón de la cultura en la gran pantalla
              </h2>
            </div>
            <p className="text-white/70 text-lg leading-relaxed">
              EventCinema.es no es solo un portal de entradas; es la plataforma oficial de <strong className="text-white">Versión Digital</strong>, la operadora líder en España en la distribución de contenido alternativo para cines. Desde hace años, nuestra misión ha sido llevar la magia de la Royal Opera House, la Arena de Verona o los mejores museos del mundo a tu ciudad, rompiendo las barreras geográficas para que la alta cultura esté al alcance de todos.
            </p>
          </div>

          {/* Por qué nace */}
          <div className="mb-16 p-8 bg-[var(--surface)] border border-white/5">
            <div className="flex items-center gap-3 mb-6">
              <Film size={28} className="text-[var(--primary)]" />
              <h2 className="font-['Playfair_Display'] text-3xl text-white">
                ¿Por qué nace EventCinema?
              </h2>
            </div>
            <p className="text-white/70 text-lg leading-relaxed mb-6">
              Creemos firmemente que <strong className="text-[var(--primary)]">ninguna butaca debería quedarse vacía</strong> mientras haya un espectador con ganas de emocionarse. Por eso, hemos creado este marketplace inteligente.
            </p>
            <p className="text-white/70 text-lg leading-relaxed">
              En colaboración directa con los exhibidores (los cines), hemos diseñado un modelo de gestión eficiente que permite a los amantes de la cultura acceder a sesiones exclusivas con condiciones especiales. Al optimizar el aforo de las salas de forma anticipada, podemos ofrecerte precios más competitivos sin sacrificar ni un ápice de la calidad técnica y artística que caracteriza a nuestras producciones.
            </p>
          </div>

          {/* Garantía */}
          <div className="mb-16">
            <div className="flex items-center gap-3 mb-8">
              <Shield size={28} className="text-[var(--primary)]" />
              <h2 className="font-['Playfair_Display'] text-3xl text-white">
                Nuestra Garantía
              </h2>
            </div>
            <p className="text-white/70 text-lg mb-8">
              Al comprar en EventCinema.es, cuentas con el respaldo directo de la distribuidora oficial:
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="p-6 bg-[var(--surface)] border border-white/5 text-center">
                <div className="w-12 h-12 bg-[var(--primary)]/20 flex items-center justify-center mx-auto mb-4">
                  <Shield size={24} className="text-[var(--primary)]" />
                </div>
                <h3 className="text-white font-medium mb-2">Autenticidad</h3>
                <p className="text-white/50 text-sm">
                  Entradas 100% garantizadas en colaboración con los principales circuitos de cine de España.
                </p>
              </div>
              
              <div className="p-6 bg-[var(--surface)] border border-white/5 text-center">
                <div className="w-12 h-12 bg-[var(--primary)]/20 flex items-center justify-center mx-auto mb-4">
                  <Users size={24} className="text-[var(--primary)]" />
                </div>
                <h3 className="text-white font-medium mb-2">Curaduría</h3>
                <p className="text-white/50 text-sm">
                  Solo ofrecemos los mejores títulos de ópera, ballet, arte y grandes conciertos.
                </p>
              </div>
              
              <div className="p-6 bg-[var(--surface)] border border-white/5 text-center">
                <div className="w-12 h-12 bg-[var(--primary)]/20 flex items-center justify-center mx-auto mb-4">
                  <Building2 size={24} className="text-[var(--primary)]" />
                </div>
                <h3 className="text-white font-medium mb-2">Sostenibilidad Cultural</h3>
                <p className="text-white/50 text-sm">
                  Cada entrada comprada aquí ayuda a que los cines sigan apostando por una programación diversa y de calidad.
                </p>
              </div>
            </div>
          </div>

          {/* Closing */}
          <div className="text-center py-12 border-t border-white/10">
            <p className="font-['Playfair_Display'] text-2xl text-white mb-4">
              Somos los que amamos el cine tanto como tú.
            </p>
            <p className="text-[var(--primary)] text-xl font-medium">
              Somos Versión Digital.
            </p>
          </div>

          {/* CTA */}
          <div className="text-center">
            <Link to="/catalogo" className="btn-primary inline-flex items-center gap-2">
              Explorar Eventos
            </Link>
            <Link to="/condiciones" className="btn-outline inline-flex items-center gap-2 ml-4">
              Ver Condiciones
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
